var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatvBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69116 11.2246V13.0299C3.69116 14.4782 4.84485 15.652 6.2684 15.652C7.69194 15.652 8.84564 14.4782 8.84564 13.0299V3.62208C8.84564 2.17377 9.99933 1 11.4229 1C12.8464 1 14.0001 2.17377 14.0001 3.62208V9.21327",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.74295H6.45768V8.99433C6.45768 10.2221 5.47833 11.2185 4.27157 11.2185H3.1861C1.97935 11.2185 1 10.2221 1 8.99433V5.74295Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66175 3.42926H1.7959V5.74286H5.66175V3.42926Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6001 1.85535L3.6001 3.15533",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatvBlue);
export default __webpack_public_path__ + "static/media/CATVBlue.5825a4151ff02c1748ba50eb597a423e.svg";
export { ForwardRef as ReactComponent };